import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { HotelRoomResponse } from 'app/typings/core/admin/rooms/room';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type RoomsResponse = {
  rooms: HotelRoomResponse[];
};

export function useGetRoomsByHotelId(id?: string | number) {
  const hotelId = id?.toString();

  return useQuery({
    queryKey: [CORE_QUERY_KEYS.rooms, { id: hotelId }],
    queryFn: hotelId
      ? () =>
          apiRequest({
            path: ENDPOINTS.getRoomsByHotelId,
            params: { id: hotelId },
          }) as Promise<RoomsResponse>
      : () => Promise.resolve(undefined),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId,
  });
}
